import React from 'react'

import { useCloseShareForm, useShareForm } from './_context/ShareFormContext'
import Modal from '../../../components/structure/Modal'
import SharePrivateForm from './SharePrivateForm'
import SharePublicForm from './SharePublicForm'

const ShareFormModal = () => {
  const form = useShareForm()
  const onClose = useCloseShareForm()

  return (
    <Modal open={!!form && !!form.id} onClose={onClose}>
      {form.access === 'public' ? <SharePublicForm /> : <SharePrivateForm />}
    </Modal>
  )
}

export default ShareFormModal
